'use strict';
import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('aeivedlysCtrl', ['$scope', '$http', '$log', 'ajaxSearch', function ($scope, $http, $log, ajaxSearch) {
	$scope.combinations = aeivedlysData.combinations;
	$scope.dataUrl = aeivedlysData.dataUrl;
	$scope.objectSearched = false;
	$scope.lng = '';
	$scope.igg = '';
	$scope.lgg = '';
	$scope.link = '';
	$scope.text_col = '';
	$scope.links = [];
	$scope.objekto_numeris = aeivedlysData.objectNo;
	$scope.item = {
		LOG: '',
		IGG: '',
		LGG: ''
	};
	$scope.displayStatus = 0;

	$scope.findUrl = aeivedlysData.findUrl;
	$scope.postUrl = aeivedlysData.submitUrl;//aeivedlysData.submitUrl
	$scope.isFeatured = false;
	$scope.trySubmit = false;
	$scope.loading = false;
	$scope.submited = false;
	$scope.messages = [];
	$scope.addresses = [];
	$scope.showSuggest = false;

	$scope.emailPattern = /^.+@[^@;!`~#$%\^&*\(\)=+]{2,}\.[a-z]{2,6}$/;
	$scope.housePattern = /^[0-9]/;

	function getDefaultData() {
		return {
			address: '',
			obj_numeris: '',
			address_id: null,
			email: ''
		};
	}
	$scope.formData = getDefaultData();


	$scope.choiseChanged = function () {
		if ($scope.lng && $scope.igg && $scope.lgg) {
			$scope.link = $scope.combinations['' + $scope.lng + '' + $scope.igg + '' + $scope.lgg];
		}
	};

	$scope.setDisplayStatus = function (status) {
		$scope.displayStatus = status;
	};

	$scope.resetRadioValues = function () {
		$scope.lng = null;
		$scope.igg = null;
		$scope.lgg = null;
	};

	$scope.gotoLink = function () {
		if ($scope.lng === '0' && $scope.igg === '0' && $scope.lgg === '0') {
			$scope.setDisplayStatus(1);
			return;
		}
		if ($scope.lng === '1' && $scope.igg === '1' && $scope.lgg === '0') {
			$scope.links = $scope.combinations['' + $scope.lng + '' + $scope.igg + '' + $scope.lgg];
			$scope.setDisplayStatus(2);
			return;
		}
		location.href = $scope.link;

		$scope.resetRadioValues();
	};

	$scope.getIconPath = function (item) {
		return theme_path + item.icon;
	};

	$scope.searchObjectNr = function () {
		$scope.submited = false;
		$scope.responseFalse = false;
		$scope.objectSearched = false;
		$scope.clearAddressSugggests();
		$scope.formData = getDefaultData();
		$scope.text_col = '';
		$scope.checking_nr = true;
		$scope.error_message = '';
		$scope.isFeatured = false;
		$scope.messages = [];
		$scope.item = {
			LOG: '',
			IGG: '',
			LGG: ''
		};
		if ($scope.dataUrl !== '' && $scope.objekto_numeris !== '') {
			$http({
				method: 'POST',
				url: $scope.dataUrl,
				data: {
					nr: $scope.objekto_numeris
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				if (response.data.success) {
					if(response.data.is_featured){
						$scope.isFeatured = true;
						$scope.formData.obj_numeris = $scope.objekto_numeris;
					}
					if(response.data.data){
						for (let list of response.data.data) {
							$scope.objectSearched = true;
							if (list.text_col !== '' && $scope.text_col === '') {
								$scope.text_col = list.text_col;
							}
							if (typeof (list.tipas) !== 'undefined') {
								if (list.tipas === 'LOG') {
									$scope.item.LOG = list.galia;
								}
								if (list.tipas === 'IGG') {
									$scope.item.IGG = list.galia;
								}
								if (list.tipas === 'LGG') {
									$scope.item.LGG = list.galia;
								}
							}
						}
					}
				} else {
					$scope.error_message = response.data.message;
				}
			}, function (response) {
				console.log(['Error', response]);
			}).then(function () {
				$scope.checking_nr = false;
			});
		}
	};

	$scope.findAddress = function () {
		$scope.formData.address_id = null;
		if ($scope.findUrl !== '' && $scope.formData.address != '') {

			$scope.loading = true;
			$scope.show_bad_searches = false;
			$scope.clearAddressSugggests();

			ajaxSearch.search($scope.findUrl, {address: $scope.formData.address}).then(function (response) {
				if (response.success) {
					$scope.addresses = response.items;
					if ($scope.addresses.length > 0) {
						$scope.showSuggest = true;
						$scope.show_bad_searches = false;
					} else {
						$scope.addresses = [];
						$scope.messages = response.messages;
						/*$scope.number_bad_searches += 1;
						 if ($scope.number_bad_searches >= $scope.limit_bad_searches) {
						 $scope.show_bad_searches = true;
						 }*/
						if ($scope.formData.address != '' && $scope.formData.address.length >= $scope.bad_address_length) {
							$scope.show_bad_searches = true;
						}
					}
					$scope.loading = false;
				}
			}, function (response) {
				$log.error(response);
			});
		} else {
			$scope.clearAddressSugggests();
		}
	};

	$scope.setAddress = function (address) {
		$scope.formData.address_id = address._source.adr_id;
		$scope.formData.address = address._source.adr_sudetinis_adresas;
		$scope.clearAddressSugggests();
	};

	$scope.clearAddressSugggests = function () {
		$scope.showSuggest = false;
		$scope.addresses = [];
		$scope.messages = [];
	};


	$scope.isSetMandatoryAddress = function () {
//		if (!$scope.formData.address_id || $scope.formData.address_id === '') {
//			return false;
//		}
		return true;
	};

	$scope.isValid = function () {
		if (!$scope.isSetMandatoryAddress()) {
			return false;
		}
		return true;
	};

	$scope.submitForm = function (form) {
		$scope.trySubmit = true;
		if ($scope.isValid() && $scope.postUrl && $scope.postUrl !== '') {
			$scope.loading = true;
			if(typeof aeivedlysData.recaptcha !== 'undefined'){
				grecaptcha.ready(function() {
					grecaptcha.execute(aeivedlysData.recaptcha.siteKey, {action: 'submit'}).then(function(token){
						if(typeof aeivedlysData.recaptcha !== 'undefined'){
							$scope.formData[aeivedlysData.recaptcha.field] = token;
						}
						$scope.submitFormPost(form);
					});
				});
			}
			else{
				$scope.submitFormPost(form);
			}
		} else {
			form.$submitted = false;
		}
	};

	$scope.submitFormPost = function (form) {
		$scope.messages = [];
		$scope.responseFalse = false;
		$http({
			method: 'POST',
			url: $scope.postUrl,
			data: $scope.formData
		}).then(function (response) {
			if (response.data.success) {
				$scope.submited = true;
				form.$setPristine();
				form.$setUntouched();
				form.$submitted = false;
				if (typeof response.data.messages !== 'undefined' && response.data.messages.length > 0) {
					$scope.messages = response.data.messages;
				}
			} else {
				form.$submitted = false;
				$scope.responseFalse = true;
				if (typeof response.data.messages !== 'undefined' && response.data.messages.length > 0) {
					$scope.messages = response.data.messages;
				}
			}
		}).then(function () {
			$scope.loading = false;
		});
	};


	if($scope.objekto_numeris != ''){
		$scope.searchObjectNr();
	}
}]);
